export default "__VITE_ASSET__D_baHmit__"